import { render, staticRenderFns } from "./importOrg.vue?vue&type=template&id=920debba&scoped=true"
import script from "./importOrg.vue?vue&type=script&lang=js"
export * from "./importOrg.vue?vue&type=script&lang=js"
import style0 from "./importOrg.vue?vue&type=style&index=0&id=920debba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920debba",
  null
  
)

export default component.exports